import React, { useState, useEffect } from 'react';
import './styles.css';
import GameButton from '../../../components/GameButton';

const flashcardsData = {
  "Higienização Bucal": [
    {
      question: "Quantas vezes devemos escovar os dentes durante o dia?",
      answer: "De 2 a 3 vezes por dia e não devemos esquecer o fio dental."
    },
    {
      question: "O que acontece se não escovarmos os dentes regularmente?",
      answer: "Pode causar cáries, mau hálito, problemas na gengiva e até perda do dente!"
    },
    {
      question: "Porque o fio dental é importante?",
      answer: "Ele consegue remover os restos alimentares que ficam entre os dentes que a escova não alcança!"
    },
    {
      question: "O que podemos fazer, além da escovação, para manter os dentes saudáveis?",
      answer: "Alimentar de forma saudável, beber água e visitar o dentista regularmente!"
    }
  ],
  "Principais Problemas Bucais": [
    {
      question: "O que é Cárie?",
      answer: "É uma doença causada por bactérias que destroem o esmalte do dente, formando cavidades (buracos)!"
    },
    {
      question: "Quais os alimentos aumentam o risco de cárie?",
      answer: "Alimentos com muito açúcar, refrigerante e carboidratos fermentáveis, como bolacha!"
    },
    {
      question: "Como podemos evitar cáries?",
      answer: "Escovando os dentes corretamente, usando o fio dental, reduzindo o consumo de açúcares e indo ao dentista regularmente."
    },
    {
      question: "O que acontece se não tratarmos a cárie?",
      answer: "Ela pode crescer, causar dor, infecção e até levar à perda do dente."
    },
    {
      question: "O que é gengivite?",
      answer: "É uma inflamação da gengiva causada pelo acúmulo de placa bacteriana."
    }
  ],
  "Saúde Bucal": [
    {
      question: "Qual é a principal função do aparelho ortodontico?",
      answer: "Corrigir dentes tortos, e problemas de mordidas, melhorando a estética e função."
    },
    {
      question: "O clareamento dental pode ser feito com produtos vendidos nas farmácias?",
      answer: "Não! Sempre deverá ser feito sob supervisão de um dentista!"
    },
    {
      question: "O que são dentes siso?",
      answer: "São os ultimos dentes a nascerem dentro da boca!"
    }
  ]
};

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const temas = Object.keys(flashcardsData);

export default function Flashcards({ tema }) {
  const [selectedTheme, setSelectedTheme] = useState('');
  const [cards, setCards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const themeToUse = tema && flashcardsData[tema] ? tema : temas[Math.floor(Math.random() * temas.length)];
    const shuffledCards = shuffleArray(flashcardsData[themeToUse]);

    setSelectedTheme(themeToUse);
    setCards(shuffledCards);
    setCurrentIndex(0);
    setFlipped(false);
  }, [tema]);

  const handleNext = () => {
    setFlipped(false);
    setCurrentIndex((prev) => (prev + 1) % cards.length);
  };

  if (!cards.length) return null;

  return (
    <div className="flashcards-container bg-game-2">
      <h2>{selectedTheme}</h2>
      <div
        className={`flashcard ${flipped ? 'flipped' : ''}`}
        onClick={() => setFlipped(!flipped)}
        style={{ cursor: 'pointer' }}
      >
        <div className="front">{cards[currentIndex].question}</div>
        <div className="back">{cards[currentIndex].answer}</div>
      </div>

      <div style={{ marginLeft: `${flipped ? '-25px' : '30px'}` }} >
        <GameButton
          text="Próxima"
          variant="info"
          style={{ marginTop: '40px'}}
          onClick={handleNext}
        />
      </div>
    </div>
  );
}
